export default "__VITE_ASSET__21d566f2__"